import { Injectable, Inject } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { APIBase } from './api.base';
import { Router } from '@angular/router';
import { SessionStorageService } from '../services/session-storage.service';

@Injectable()
export class LeadsAPI extends APIBase {

	constructor(@Inject(AuthHttp) authHttp: AuthHttp, @Inject(Router) router: Router, @Inject(SessionStorageService) session: SessionStorageService) {
		super(authHttp, router, session);

		// Entidade principal
		this.__entity = 'leads';
	}
		/**
	 * save
	 *
	 * Salva os dados
	 *
	 * @access public
	 * @author Elian Medeiros
	 * @since  05/2018
	 * @param  object
	 * @return object Promise
	 */
	public save(data) {
		return this._call(this.__entity + '/save', data);
	}
}


// WEBPACK FOOTER //
// ./src/api/leads.api.ts